import {useEffect, useLayoutEffect, useRef, useState} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { MODELS } from './../../../../../Apis/Models';
import { TABLES } from './../../../../../Apis/Tables';
import { permissionObj } from './../../../../../Helpers/permission';
import { TABS_GUARD, VISITOR_VIEWS_FROM } from '../Model/Model';
import { useParamsContextProvider } from '../../../../../hooks/ParamsContextProvider';
import { MODEL_CONTEXT } from '../../../Dining/Model/Models';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';

/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 */

export const GuardMainApp = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    let { state } = location;
    const currentTab = state?.currentTab;
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    const [selectedList, setSelectedList] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [bodyForExport, setBodyForExport] = useState('');
    const { paramsContext, setParamsContext } = useParamsContextProvider();
    // Search functionality
    const [search, setSearch] = useState(false); // Search flag
    const [searchElement, setSearchElement] = useState(''); // Search filter value
    const [subView, setSubView] = useState(null);
    const [modified, setModified] = useState(false);
    const [finalArray, setFinalArray] = useState([]);
    const [criteria, setCriteria] = useState();
    const dispatch = useDispatch();

    // IDs for module and option being handled
    const [moduleId, setModuleId] = useState(`${MODELS.VISITOR_INVITATION}`);
    const [option, setOption] = useState(`${TABLES.USER_INVITATION}`);

    // Flags to show modals for creating new visitors or requesting access
    const [showCreateNewVisitorModal, setShowCreateNewVisitorModal] = useState(false);
    const [showRequestAccessModal, setShowRequestAccessModal] = useState(false);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const showSuccessMsgRef = useRef(false);
    // Flag to indicate if the current user is a visitor
    const [viewOrigin, setViewOrigin] = useState(VISITOR_VIEWS_FROM.VISITOR_GUARD);
    useLayoutEffect(() => {
        if (!paramsContext || paramsContext == null) {
            setParamsContext({ ...MODEL_CONTEXT });
        }
    }, []);

    /**
     * Effect hook to set up steps based on permissions and development mode.
     * Also sets the default active step depending on the available permissions.
     */
    useLayoutEffect(() => {
        let activeTab = null;
        const stepConfig = [
            {
                tab: TABS_GUARD.VISITORS.TRANS,
                perm: [permissionObj?.WEB_VISITOR_READ],
                index: TABS_GUARD.VISITORS.INDEX,
            },
            {
                tab: TABS_GUARD.REQUESTS.TRANS,
                perm: [permissionObj?.WEB_REQUEST_ACCESS_READ],
                index: TABS_GUARD.REQUESTS.INDEX,
            },
        ];

        const auxStep = stepConfig.reduce((acc, { tab, perm, index }) => {
            const hasPermission = DEV || perm.some((p) => permission?.includes(p));
            if (hasPermission) {
                acc.push({ label: t(tab), index: index });
                if (activeTab === null) activeTab = index;
            }
            return acc;
        }, []);

        setSteps(auxStep);

        if (activeTab !== null && !currentTab) handleStepChange(activeTab);
    }, [t, permission]);
    /**
     * Hook to return to the current tab based on the index stored in the Context.
     */
    useEffect(() => {
        if (paramsContext?.tabIndex !== null && typeof paramsContext?.tabIndex !== 'undefined')
            handleStepChange(paramsContext?.tabIndex);
    }, []);

    /**
     * Handles changing the active step.
     * Resets the selected items list when the step changes.
     *
     * @param {number} step - The index of the step to activate.
     */

    const handleStepChange = (step) => {
        setActiveStep(step);
        if (setParamsContext)
            setParamsContext((prev) => ({
                ...prev,
                tabIndex: step,
            }));
        switch (step) {
            case TABS_GUARD.VISITORS.INDEX:
                break;
            case TABS_GUARD.REQUESTS.INDEX:
                break;
            default:
                break;
        }
    };
    /**
         * Function for the create and/or delete action, where the modalDelete and modalCreate variables can be activated and/or a view redirection can be performed.
         * @param Boolean isCreate: If the variable is true, it indicates that the action was triggered from the create button; otherwise, the action was triggered from the delete button.
         */
    const handleCreateDelete = (action = ACTION_MODEL.CREATE) => {
        if (setParamsContext && paramsContext.tabIndex === TABS_GUARD.REQUESTS.INDEX) {
            setParamsContext((prev) => ({
                ...prev,
                [action === ACTION_MODEL.CREATE ? 'modalCreate' : 'modalDelete']: true,
            }));
        }
        switch (paramsContext.tabIndex) {
            case TABS_GUARD.VISITORS.INDEX:
                if (setParamsContext) {
                    if (action === ACTION_MODEL.CREATE) {
                        setShowCreateNewVisitorModal(true);
                    }
                }
                break;

            case TABS_GUARD.REQUESTS.INDEX:
                break;
            default:
                break;
        }
    };
    /**
        * Validate permissions for the create and delete buttons.
        * @param array list: List of permissions based on the active tab.
        * @returns {boolean}
        */
    const permissionButtons = (list) => {
        if (paramsContext?.tabIndex == null) {

            return false;
        }

        const permissionRequired = list[paramsContext?.tabIndex];


        if (!permissionRequired) {
            return false;
        }

        return DEV || permission?.includes(permissionRequired);
    };

    return {
        t,
        dispatch,
        DEV,
        permission,
        navigate,
        steps,
        setCriteria,
        activeStep,
        setActiveStep,
        setDeleteModal,
        deleteModal,
        search,
        setSearch,
        searchElement,
        setSearchElement,
        modified,
        setModified,
        handleStepChange,
        setShowCreateNewVisitorModal,
        showCreateNewVisitorModal,
        setOption,
        setModuleId,
        subView,
        setSubView,
        finalArray,
        setSelectedList,
        selectedList,
        viewOrigin, setViewOrigin,
        setShowRequestAccessModal,
        showRequestAccessModal,
        permissionButtons,
        handleCreateDelete,
        setBodyForExport,
        showSuccessMsgRef
    };
};
